<template>
  <div id="relic-detail">
    <!-- 头部 -->
    <header class="relic-detail__header flex-align">
      <h2 class="header-title font-h2 flex-align">
        <el-input
          v-if="headerEditFlag"
          v-model="relicDetail.relicFromUserId"
          :readonly="!headerEditFlag"
          class="header-title__number header-title__name"
          :class="{ readonly: !headerEditFlag }"
        />
        <span v-if="!headerEditFlag" class="font-h3">{{
          relicDetail.relicFromUserId
        }}</span>
        <el-input
          v-model="relicDetail.relicName"
          :readonly="!headerEditFlag"
          class="header-title__name"
          :class="{ readonly: !headerEditFlag }"
        />
      </h2>
      <el-button @click="handleGoback" class="header-back" type="primary" plain
        >返回</el-button
      >
    </header>

    <!-- 基本信息 -->
    <div style="padding-top:80px">
      <relic-detail-base-vue v-model="relicDetail" />
      <!-- 建筑标签
      <relic-detail-tags-vue /> -->

      <!-- 规划信息 -->
      <relic-detail-plain-vue v-model="relicDetail" />

      <!-- 普查信息 -->
      <relic-detail-census-vue />
      <!-- 巡查报告 -->
      <relic-detail-report
        v-if="false"
        :reportList="reportList"
        @onDeleteReport="handleDeleteReports"
        @onRefreshReport="getRreportList"
      />
      <!-- 修缮记录 -->
      <relic-detail-repair
        v-if="false"
        :repairList="repairList"
        @onRefreshRepairList="initRepairData"
        @onDeleteRepair="handleDeleteRecords"
      />
    </div>
  </div>
</template>

<script>
import relicDetailBaseVue from '../../components/relic/relic-detail-base.vue';
// import relicDetailTagsVue from '../../components/relic/relic-detail-tags.vue';
import relicDetailPlainVue from '../../components/relic/relic-detail-plain.vue';
import relicDetailCensusVue from '../../components/relic/relic-detail-census.vue';
import {
  deleteReport,
  searchReports,
  GetRepairList,
  DeleteRepairData
} from '../../api/index';
import { mapActions, mapMutations, mapState } from 'vuex';
import RelicDetailReport from '../../components/relic/relic-detail-report.vue';
import RelicDetailRepair from '../../components/relic/relic-detail-repair.vue';
import { AREA_MAP, STATUS_MAP, REPORT_TYPE_MAP } from '../../config/constant';

export default {
  name: 'RelicDetail',

  components: {
    relicDetailBaseVue,
    // relicDetailTagsVue,
    relicDetailPlainVue,
    relicDetailCensusVue,
    RelicDetailReport,
    RelicDetailRepair
  },

  data() {
    return {
      headerEditFlag: false, // 头部编辑状态控制，由子组件<relicDetailBaseVue>控制
      reportList: [],
      repairList: [] //修缮记录
    };
  },
  computed: {
    ...mapState('relic', ['relicDetail']),
    relicId() {
      return this.$route.params.id;
    },
    relicTitle() {
      return `${this.relicId} ${this.relicDetail?.relicName}`;
    }
  },

  created() {
    this.getRelicDetail(this.relicId);
  },
  methods: {
    ...mapMutations('relic', ['setRelicDetail']),
    /**
     * 返回列表
     */
    handleGoback() {
      this.$router.push({ name: 'Relic' });
    },
    async getRelicDetail(id) {
      // const {
      //   data: { data: relicData }
      // } = await getRelicDetail(id);
      await this.getBaseRelicInfo(id);
      // await this.getRreportList(id);
      // await this.initRepairData(id);
      // relicData.updateTime = this.formatDateTime(relicData.updateTime);
      // this.relicDetail = relicData;
      // this.setRelicDetail(relicData);
    },

    /**
     * 获取巡查报告最新的十条
     * @param {string} id 巡查报告自增id
     */
    async getRreportList(id = this.relicId) {
      const {
        data: {
          data: { items }
        }
      } = await searchReports({
        page: 1,
        pageSize: 10,
        relicAutoIncrementId: id
      });
      const formateData = items.map(item => {
        item.createTime = this.formatDateTime(item.createTime);
        item.inspectStatusEnum = STATUS_MAP.get(item.inspectStatusEnum);
        item.inspectTypeEnum = REPORT_TYPE_MAP.get(item.inspectTypeEnum);
        item.relicDistrictEnum = AREA_MAP.get(item.relicDistrictEnum);
        return item;
      });
      this.reportList = formateData;
    },

    /**
     * 删除巡查报告
     * @param {Array} list
     */
    async handleDeleteReports(list) {
      // const reportIdList = list
      //   .map(({ inspectReportId: id }) => `inspectReportId=${id}`)
      //   .join('&');
      await deleteReport(list);
      this.getRreportList(this.relicId);
    },

    /**
     * 获取修缮记录列表
     */
    async initRepairData(id = this.relicId) {
      const {
        data: {
          data: { items }
        }
      } = await GetRepairList({
        page: 1,
        pageSize: 10,
        relicAutoIncrementId: id,
        acceptanceDateSort: true
      });
      //
      this.repairList = items;
    },

    /**
     * 监听删除回调
     */
    async handleDeleteRecords(list) {
      const promises = [];
      list.forEach(item => {
        const { repairRecordUid } = item;
        promises.push(DeleteRepairData(repairRecordUid));
      });
      await Promise.all(promises);
      this.initRepairData();
      this.$prompt('删除成功');
    },
    ...mapActions('relic', ['getBaseRelicInfo', 'getPhotoList'])
  }
};
</script>

<style lang="scss">
#relic-detail {
  .relic-detail {
    &__header {
      position: fixed;
      padding: 13px 0 25px;
      // box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
      width: 1024px;
      background-color: #fff;
      z-index: 2000;
      justify-content: space-between;
    }
  }
  .header {
    &-title {
      font-size: 18px;
      font-weight: 700;
      color: #003333;
      &__number {
        width: 150px !important;
      }
      &__name {
        margin-left: 3px;
        width: 370px;
        &.readonly {
          .el-input__inner {
            font-size: 14px;
            font-weight: 700;
            color: #003333;
            box-shadow: none;
          }
        }
        .el-input__inner {
          padding: 0 3px;
          height: 30px;
          font-size: 13px;
          line-height: 30px;
          color: #000;
          border: 0;
          border-radius: unset;
          box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
        }
      }
    }
  }
}
.relic-dialog {
  .el-dialog {
    &__title {
      font-size: 22px;
      color: #333;
      font-family: 'Arial';
    }
    &__headerbtn {
      font-size: 35px;
      line-height: 1;
      top: -4px;
      right: -42px;
    }
    &__close {
      color: #fff;
    }
  }
}
</style>
